import request from '@/utils/request'
import {guid} from "@/utils/ruoyi";


// 查询商品列表
export function listGoods(query) {
  return request({
    url: '/biz/admin/goods/goods/list',
    method: 'get',
    params: query
  })
}

// 查询商品分页
export function pageGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

/*积分商城商品*/
export function pageScoreGoods(data) {
  return request({
    url: '/biz/admin/goods/score/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


export function pageSelectGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/select/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function listSelectGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/select/list',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function pageSelectGoodsSku(data) {
  return request({
    url: '/biz/admin/goods/sku/select/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function listSelectGoodsSku(data) {
  return request({
    url: '/biz/admin/goods/sku/select/list',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


export function getMallGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/mall/detail',
    method: 'get',
    params: data
  })
}


export function getScoreGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/score/detail',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

// 查询商品详细
export function getGoodProperty(data) {
  return request({
    url: '/biz/admin/goods/property/tree',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

// 查询商品详细
export function goodGongshiAdd(data) {
  return request({
    url: '/biz/admin/goods/formula/add',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

// 查询商品详细
export function getGoodsPropertyLeaf(data) {
  return request({
    url: '/biz/admin/goods/property/leaf',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

// 查询商品详细
export function editGoodsFormula(data) {
  return request({
    url: '/biz/admin/goods/formula/edit',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


// 查询商品库存详细
export function getGoodsStock(data) {
  return request({
    url: '/biz/admin/goods/goods/detail/stock',
    method: 'get',
    params: data
  })
}



// 新增商品
export function addMallGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/mall/add',
    method: 'post',
    data: data
  })
}

export function updateMallGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/mall/edit',
    method: 'post',
    data: data
  })
}


// 新增商品
export function addScoreGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/score/add',
    method: 'post',
    data: data
  })
}

export function updateScoreGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/score/edit',
    method: 'post',
    data: data
  })
}


export function updateGoodsStock(data) {
  return request({
    url: '/biz/admin/goods/goods/edit/stock',
    method: 'post',
    data: data
  })
}

// 删除商品
export function delGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/delete',
    method: 'post',
    data: data
  })
}

// 批量更新商品排序
export function updateGoodsSort(data) {
  return request({
    url: '/biz/admin/goods/goods/updateSort',
    method: 'post',
    data: data
  })
}


export function batchOn(data) {
  return request({
    url: '/biz/admin/goods/goods/batchOn',
    method: 'post',
    data: data
  })
}


export function batchOff(data) {
  return request({
    url: '/biz/admin/goods/goods/batchOff',
    method: 'post',
    data: data
  })
}


export function batchAudit(data) {
  return request({
    url: '/biz/admin/goods/goods/batchAudit',
    method: 'post',
    data: data
  })
}

export function batchCopy(data) {
  return request({
    url: '/biz/admin/goods/goods/copy',
    method: 'post',
    data: data
  })
}



// 查询商品分页
export function pageUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


// 新增校服商品
export function addUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/add',
    method: 'post',
    data: data
  })
}
// 修改校服商品
export function updateUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/edit',
    method: 'post',
    data: data
  })
}


// 查询商品详细 -校服
export function getUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/detail',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


export function pageSelectUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/select/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function listSelectUniformGoods(data) {
  return request({
    url: '/biz/admin/goods/goods/uniform/select/list',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}